import { openBlock as e, createElementBlock as c, createElementVNode as l } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, o = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M2.894 14.13c.623 0 1.115-.293 1.477-.702.345-.389.59-.9.78-1.427.108-.298.205-.623.294-.965L9.801 6.68c.129.474.25.98.37 1.5l-5.045 5.045a.5.5 0 1 0 .707.707l4.6-4.6c.117.512.238 1.02.369 1.501l-2.378 2.378a.5.5 0 1 0 .707.707l2.005-2.005.035.095c.156.418.342.824.576 1.166l-.023.023a.5.5 0 1 0 .707.707l.027-.027c.253.154.548.252.888.252a.75.75 0 0 0 0-1.5c-.04 0-.123-.007-.27-.182-.16-.189-.328-.504-.5-.963-.301-.81-.541-1.87-.803-3.024l-.001-.004c-.035-.155-.07-.312-.107-.47-.296-1.294-.632-2.678-1.125-3.742-.475-1.024-1.248-2.067-2.554-2.067-1.325 0-2.058 1.067-2.484 2.096-.442 1.065-.715 2.452-.958 3.74l-.046.245c-.235 1.24-.45 2.38-.757 3.233-.164.453-.331.76-.493.942-.144.162-.252.196-.354.196a.75.75 0 1 0 0 1.5Zm6.575-8.532L5.84 9.226l.123-.648.053-.285c.091-.48.182-.948.278-1.392L8.877 4.32c.099.151.2.335.302.556.103.222.199.464.29.722ZM8.096 3.686a.707.707 0 0 0-.11-.008c-.34 0-.712.239-1.099 1.17a5.99 5.99 0 0 0-.032.079l1.24-1.24Z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  o
];
function r(a, d) {
  return e(), c("svg", t, [...n]);
}
const i = { render: r };
export {
  i as default,
  r as render
};
